import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationDollyEnvelope } from './types';

/** `{ dolly: null }` when the organization has no (live) Dolly configuration. */
export async function getOrganizationDolly(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/dolly`;

  const response = await api.executeGetRequest<ObjectResponse<OrganizationDollyEnvelope>>(url);

  return response.data;
}
